import { DestroyRef, Injectable, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { DynamicDialogRef } from '@openng/optimus-ui/dynamicdialog';
import { take } from 'rxjs';
import { IplpRecipeDetailObject } from '@libs/types/src/list/object-type/iplp-recipe.object';
import { BaseDialogService } from '../../../../kit/base-dialog/base-dialog-service';
import {
    FolderEPrescriptionMagistraliterRecipesDialogComponent,
} from '../folder-e-prescription-magistraliter-recipes-dialog/folder-e-prescription-magistraliter-recipes-dialog.component';

@Injectable()
export class FolderEPrescriptionMagistraliterRecipesStore {
    private readonly dialogService = inject(BaseDialogService);
    private readonly translate = inject(TranslateService);
    private readonly destroyRef = inject(DestroyRef);

    public readonly opened = signal(false);

    private dialog: DynamicDialogRef | null = null;

    constructor() {
        this.destroyRef.onDestroy(() => this.dialog?.close());
    }

    public open(onSelected: (recipe: IplpRecipeDetailObject) => void): void {
        if (this.opened()) return;
        this.opened.set(true);
        this.dialog = this.dialogService.open(FolderEPrescriptionMagistraliterRecipesDialogComponent, {
            header: this.translate.instant('ePrescriptions.magistraliterRecipes.title'),
            styleClass: 'p-dialog-width-80',
            focusOnShow: true,
        });
        this.dialog.onClose.pipe(take(1), takeUntilDestroyed(this.destroyRef))
            .subscribe((recipe: IplpRecipeDetailObject | undefined) => {
                this.opened.set(false);
                this.dialog = null;
                if (recipe) onSelected(recipe);
            });
    }
}
